import React from "react";
import PageBanner from "../components/pageBanner";
import ContactForm from "../components/contact/ContactForm";
import Address from "../components/contact/address";
import { NextSeo } from 'next-seo';

const Contact = () => {
  const metaTitle = "Contact - Alchemis";
  const metaDesc = `.`;
  const metaImg = `/images/meta/general.png`;
  return (
    <div>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <div>
        <PageBanner text="Get in touch" image={'/images/about/banner-bg.png'} />

        {/* <!-- Contact --> */}
        <section className="dark:bg-jacarta-800 relative py-24">
          <div className="container">
            <div className="lg:flex">
              {/* <!-- Contact Form --> */}
              <div className="mb-12 lg:mb-0 lg:w-2/3 lg:pr-12">
                <h2 className="font-display text-jacarta-700 mb-4 text-xl dark:text-white">
                  Contact Us
                </h2>
                <p className="dark:text-jacarta-300 mb-16 text-lg leading-normal">
                  {
                    " Have a question? Need help? Don't hesitate, drop us a line"
                  }
                </p>

                <ContactForm />
              </div>

              {/* <!-- Info --> */}
              <Address />
            </div>
          </div>
        </section>
        {/* <!-- end contact --> */}
      </div>
    </div>
  );
};

export default Contact;
